import React, { useState } from "react";
import { useEffect } from "react";
import { createMicrophoneAndCameraTracks } from "agora-rtc-react";

const errorCode = (ct) => {
  switch (ct) {
    case "PERMISSION_DENIED":
      return "Please allow camera and audio use then reload the page.";
    case "NOT_READABLE":
      return "Camera and Audio are not detected";
    default:
      return null;
  }
};

const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();

export default function useCoreAgoraCheck() {
  const { ready, tracks, error } = useMicrophoneAndCameraTracks();
  const [isMuteTrackSelf, setIsMuteTrackSelf] = useState({
    video: true,
    audio: true,
  });

  useEffect(() => {
    return () => {
      if (tracks) {
        tracks[0].close();
        tracks[1].close();
      }
    };
  }, [ready, tracks]);

  const setMuteSelfTracks = async (type, val) => {
    if (type === "audio") {
      tracks[0].setEnabled(val);
      setIsMuteTrackSelf((ps) => {
        return { ...ps, audio: !ps.audio };
      });
    } else if (type === "video") {
      tracks[1].setEnabled(val);
      setIsMuteTrackSelf((ps) => {
        return { ...ps, video: !ps.video };
      });
    }
  };

  console.log("error agora:", error?.name);
  console.log("error agora:", error?.code);
  return {
    isSelfTracksReady: ready,
    selfTracks: tracks,
    isMuteTrackSelf,
    setMuteSelfTracks,
    error: errorCode(error?.code),
  };
}
